import { createFileRoute } from '@tanstack/react-router'
import { PersonalNotePageLayout } from '../components/PersonalNotePageLayout'
import { usePersonalNoteForDate } from '../hooks/usePersonalNoteForDate'
import { formatWeeklyNoteTitle, isThisWeek } from '../utils/noteDateUtils'
import { useTimezone } from '@/store/UserPreferencesStore'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/weekly/$noteDate',
)({
  component: WeeklyNotePage,
})

function WeeklyNotePage() {
  const timezone = useTimezone()
  const { noteDate } = Route.useParams()
  const noteState = usePersonalNoteForDate('weekly', noteDate)

  return (
    <PersonalNotePageLayout
      noteType="weekly"
      noteDate={noteDate}
      title={formatWeeklyNoteTitle(noteDate)}
      isCurrentPeriod={isThisWeek(noteDate, timezone)}
      currentPeriodLabelKey="thisWeek"
      listTitleKey="weeklyNotes"
      noteState={noteState}
    />
  )
}
